import { Formik, Form, FieldArray } from 'formik';
import { useNavigate} from 'react-router-dom';
import { useSelector } from "react-redux";
import React, { useState, useEffect, useRef } from 'react';
import { AddMerchantSchema } from '../../validation/ValidationSchema';
import { api } from '../../api';
import { getAllCountries, getStateByCountry } from '../../helpers/countryState';
import { getBase64 } from '../../utils/converter';
import { getProductsList, getBrands } from '../../helpers/listsApi';
import ButtonContained from '../button';
import DropdownComp from '../dropdown';
// eslint-disable-next-line
import FleUpload from '../fileUpload/FleUpload';
import Input from '../../components/input';
import LoginDetails from './LoginDetails';
import { toast } from "react-toastify";


//row
import DynamicAddMerchantRow from '../merchantRow/addMerchantRow';
import usePasswordToggle from '../hooks/usePasswordToggle';


const AddMerchant = () => {
    const token = useSelector((state) => state.auth.token);
    const region = useSelector((state) => state.auth.region);
    // eslint-disable-next-line
    const { userType: role } = useSelector((state) => state.auth.user);
    const navigate = useNavigate();
    const fileInputRefs = useRef([]);
    const countrydata = getAllCountries();
    const [countries] = useState(countrydata)
    const [brands, setBrands] = useState([])
    // eslint-disable-next-line 
    const [products, setproducts] = useState([])
    const [states, setStates] = useState([])
    const [showDetailsModal, setShowDetailsModal] = useState(false)
    const [loginData, setLoginData] = useState({})
    const [PwdInputType, ToggleIcon] = usePasswordToggle();
    const [taxLabel, setTaxLabel] = useState('Tax Number');
    const [taxType, setTaxType] = useState('Tax Type');

    useEffect(() => {
        // eslint-disable-next-line
    if (region?.id == "1") {
        setTaxLabel('GST Number');
        setTaxType('GST');
        // eslint-disable-next-line
    } else if (region?.id == "2") {
        setTaxLabel('VAT Number');
        setTaxType('VAT');
    } else {
        setTaxLabel('Tax Number');
        setTaxType('VAT');

    }
    }, [region]);

    


    useEffect(() => {
        getBrands({},token).then(res => {
            setBrands(res);
        })
    }, [token])
    const getProductsData = (data) => {
        getProductsList(data,token).then(res => {
            setproducts(res)
        })
    }
    // eslint-disable-next-line
    const handleFileChange = (name, e, setFieldValue) => {
        setFieldValue(name, e.currentTarget.files[0])
        getBase64(e.currentTarget.files[0], res => {
            api.upload.upload(res,token).then(res => {
                setFieldValue(`${name}Base64`, res.data)
            }).catch(err => {
                setFieldValue(`${name}Base64`, {})
            })
        })
    }
    const ShowDetails = () => {
        setShowDetailsModal(true)
    }
    const closeModal = () => {
        setShowDetailsModal(false)
        navigate('/merchants');
    }

    const defaultCountry = "";
    const defaultState = getStateByCountry("India");
   // eslint-disable-next-line 
    const [firstMargin, setFirstmargin] = useState(null)


   //doc upload data
       const [documentOptions, setDocumentOptions] = useState([]);
       
    
       const [documents, setDocuments] = useState([
         { documentTypeId: '', fileName: null }
       ]);


          useEffect(() => {
           const fetchDocumentTypes = async () => {
               try {
               const response = await api.resellerType.getDocumentTypesByRegionId(
                   { resellerRegionId: region.id },
                   null
               );
               
               if (response.success === true) {
                   setDocumentOptions(response.data);
               } else {
                   setDocumentOptions([]);
               }
               } catch (error) {
               console.error('Error fetching document types:', error);
               setDocumentOptions([]);
               }
           };
   
         
               fetchDocumentTypes();
           
           }, [token,region.id]);






       
       const handleAddDocument = () => {
         const hasIncomplete = documents.some(doc => !doc.documentTypeId || !doc.fileName);
         if (hasIncomplete) {
           toast.error('Please complete all existing document entries before adding a new one.');
           return;
         }
       
         if (documents.length < 5) {
         setDocuments([
           ...documents,
           { documentTypeId: '', fileName: null}
         ]);
         }
       };
       
       const handleRemoveDocument = (index) => {
         const updated = documents.filter((_, i) => i !== index);
         setDocuments(updated);
       };
       
       const handleDocumentChange = (index, field, value) => {
         if (field === 'documentTypeId') {
           const isDuplicate = documents.some((doc, i) => doc.documentTypeId === value && i !== index);
           if (isDuplicate) {
             toast.error('This document type is already selected.');
             return;
           }
         }
       
       
         const newDocs = [...documents];
       
         if (field === 'file') {
           const file = value;

            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            const maxSizeInBytes = 1 * 1024 * 1024; // 1 MB

            if (!allowedTypes.includes(file.type)) {
                toast.error('Invalid file type. Only PDF, JPEG, and PNG are allowed.');
                if (fileInputRefs.current[index]) fileInputRefs.current[index].value = '';
                return;
            }

            if (file.size > maxSizeInBytes) {
                toast.error('File size must be less than 1MB.');
                if (fileInputRefs.current[index]) fileInputRefs.current[index].value = '';
                return;
            }
       
           getBase64(file, (base64) => {
             newDocs[index]['fileName'] = base64;
             setDocuments(newDocs); // update only after base64 is ready
           });
         } else {
           newDocs[index][field] = value;
           setDocuments(newDocs);
         }
         
       };
       

   // doc upload end






    return (
        <Formik
            validationSchema={AddMerchantSchema}
            initialValues={{
                // calcMargin: firstMargin,

                merchantName: '',
                address: '',
                country: defaultCountry,
                state: '',
                city: '',
                mobileNumber: '',
                phone: '',
                contactPerson: '',
                emailAddress: '',
                gstNumber: '',
                uploadAdhar: '',
                uploadPan: '',
                uploadAddress: '',
                uploadOtherDocs: '',
                brand: '',
                productName: '',
                marginOffer: '',
                token: '',
                authorizationCode: '',
                uploadAdharBase64: '',
                uploadPanBase64: '',
                uploadAddressBase64: '',
                uploadOtherDocsBase64: '',
                merchentApiAccess: false,
                password: '',
                cnfmPassword: '',
                brandAccess: [
                    { brand: "", productName: "", margin: "", products: [] }
                ],
                reseller_region_id: '',
                resellerType: region.name || '',
                documents: [{ documentTypeId: '', fileName: null }],
                taxNumber:'',
                is2faEnabled: true,
                ipAddress:''
            }}
             enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
            const hasInvalidDocument = documents.some(
            (doc) => !doc.documentTypeId || !doc.fileName
            );

            if (hasInvalidDocument) {
            toast.error('Please fill all required documents before submitting.');
            setSubmitting(false);
            return;
            }


                const brands = [];
                const brandIds = [];
                const brandNames = [];
                values.brandAccess.map(dt => {
                    const { brandId, productId, margin } = dt
                    brandIds.push(brandId.value);
                    brandNames.push(brandId.label)
                    if (Object.keys(brandId).length > 0 && productId.length > 0) {
                        const products = productId.map(pr => pr.value).toString();
                        brands.push({
                            brandId: brandId.value,
                            productId: products,
                            margin: margin
                        })
                    }

                    return null;
                })
                const formBody = {

                    // calcMargin: values.calcMargin,

                    merchentName: values.merchantName,
                    merchentAddress: values.address,
                    merchentCountry: values.country.value || '',
                    merchentState: values.state.value || '',
                    merchentCity: values.city,
                    merchentMobile: values.mobileNumber.toString(),
                    merchentPhone: values.phone.toString(),
                    merchentContactPerson: values.contactPerson,
                    merchentEmail: values.emailAddress,
                    // merchentGstNo: values.gstNumber,
                    merchentToken: values.token || '',
                    merchentAuthorization: values.authorizationCode || '',
                    password: values.password,
                    merchentBrandIds: brandIds.toString(),
                    merchentBrandNames: brandNames.toString(),
                    brands,
                    merchentApiAccess: values.merchentApiAccess,
                    reseller_region_id: region.id,
                    documents: documents,
                    merchenttaxNumber:values.taxNumber,
                    merchenttaxType:taxType,
                    is2faEnabled: values.is2faEnabled,
                    ipAddress: values.ipAddress
                }
                // console.log(values, ' valllll')
                // console.log(formBody, ' ffff')
                api.merchants.create(formBody,token).then(res => {
                    if (res.success === false) {
                         toast.error(res.message);
                         setSubmitting(false)
                    }
                    else {
                        setLoginData(res.data)
                        toast.success(res.message);
                        ShowDetails()
                    }

                }).catch(err => {
                    console.log('mercant create error ', err)
                    setSubmitting(false)
                     toast.error("Something went wrong!");
                });
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
                isSubmitting,
                setFieldValue

            }) => {
                return (

                    <div className="container-fluid">
                        {/* <section className="mt-4"> */}
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="box-row">
                                    <div className="table-head">
                                        <h1 className="sec-header">ADD MERCHANT</h1>
                                    </div>
                                    <div className="card card-table">
                                        <div className="card-body gatepass-saveoutput">
                                            <div className="reports">
                                                <Form onSubmit={handleSubmit}>
                                                    <div className="form-row">
                                                          <div className="form-group col-md-4">                                                                                                                                                        

                                                            <Input
                                                                name="resellerType"
                                                                id="resellerType"
                                                                label="Reseller Region"
                                                                placeholder="Reseller Region"
                                                                type="text"
                                                                value={values.resellerType}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                       
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="merchantName"
                                                                id="merchantName"
                                                                placeholder="Enter merchant name"
                                                                type="text"
                                                                label="Merchant Name"
                                                                value={values.merchantName}
                                                                onChange={handleChange}
                                                                error={touched.merchantName && errors.merchantName}
                                                                errorText={errors.merchantName}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="address"
                                                                name="address"
                                                                placeholder="Enter address"
                                                                type="text"
                                                                label="Address"
                                                                value={values.address}
                                                                onChange={handleChange}
                                                                error={touched.address && errors.address}
                                                                errorText={errors.address}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                

                                                    </div>
                                                    <div className="form-row">
                                                                <div className="form-group col-md-4">
                                                            <Input
                                                                id="city"
                                                                name="city"
                                                                placeholder="Enter city"
                                                                type="text"
                                                                label="City"
                                                                value={values.city}
                                                                onChange={handleChange}
                                                                error={touched.city && errors.city}
                                                                errorText={errors.city}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <DropdownComp
                                                                name="country"
                                                                id="country"
                                                                label="Country"
                                                                placeholder="Please select"
                                                                onChange={(selectedValue) => {
                                                                    setFieldValue("country", selectedValue)
                                                                    setFieldValue("state", "")
                                                                    const stateList = getStateByCountry(selectedValue.value)
                                                                    setStates(stateList)
                                                                }}
                                                                value={values.country}
                                                                options={countries}
                                                                error={touched.country && errors.country}
                                                                errorText={errors.country}
                                                                disabled={isSubmitting}>
                                                            </DropdownComp>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <DropdownComp
                                                                id="state"
                                                                name="state"
                                                                onChange={(selectedValue) => {
                                                                    setFieldValue("state", selectedValue)
                                                                }}
                                                                value={values.state}
                                                                options={values.country.value === "India" ? defaultState : states}
                                                                label="State"
                                                                placeholder="Please select"
                                                                error={touched.state && errors.state}
                                                                errorText={errors.state}
                                                                disabled={isSubmitting || values.country === ''}>
                                                            </DropdownComp>
                                                        </div>
                                                 
                                                    </div>
                                                    <div className="form-row">
                                                               <div className="form-group col-md-4">
                                                            <Input
                                                                id="mobileNumber"
                                                                name="mobileNumber"
                                                                placeholder="Enter mobile number"
                                                                type="number"
                                                                label=" Mobile Number"
                                                                value={values.mobileNumber}
                                                                onChange={handleChange}
                                                                error={touched.mobileNumber && errors.mobileNumber}
                                                                errorText={errors.mobileNumber}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="contactPerson"
                                                                name="contactPerson"
                                                                placeholder="Enter contact person name"
                                                                type="text"
                                                                label="Contact Person"
                                                                value={values.contactPerson}
                                                                onChange={handleChange}
                                                                error={touched.contactPerson && errors.contactPerson}
                                                                errorText={errors.contactPerson}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        {/* <div className="form-group col-md-4">
                                                            <Input
                                                                id="phone"
                                                                name="phone"
                                                                placeholder="Enter phone number"
                                                                type="number"
                                                                label=" Phone Number"
                                                                value={values.phone}
                                                                onChange={handleChange}
                                                                // error={touched.phone && errors.phone}
                                                                // errorText={errors.phone}
                                                                disabled={isSubmitting} />
                                                        </div> */}
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="emailAddress"
                                                                name="emailAddress"
                                                                placeholder="Email (Login Id)"
                                                                type="text"
                                                                label="Email (Login Id)"
                                                                value={values.emailAddress}
                                                                onChange={handleChange}
                                                                error={touched.emailAddress && errors.emailAddress}
                                                                errorText={errors.emailAddress}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>

                                                    {/* Document Upload */}

                                                  
                                                    <div className="form-row">
                                                        <div className="form-group col-md-4">
                                                             <Input
                                                                name="taxNumber"
                                                                placeholder={taxLabel}
                                                                type="text"
                                                                label={taxLabel}
                                                                value={values.taxNumber}
                                                                onChange={handleChange}
                                                                id="taxNumber"                                                              
                                                                />
                                                        </div>
                                                      
                                                    
                                                    </div>

                                                        <div className="row">
              <div className="col-md-12">
                <h6 style={{fontWeight:'bold' }}>Upload Required Documents</h6>
              </div>


         {documents.map((doc, index) => (
          <div className="form-group col-md-12 row" key={index}>
            <div className="col-md-3">
              <label>Document Type</label>
              <select
                className="form-control"
                value={doc.documentTypeId}
                onChange={(e) => handleDocumentChange(index, 'documentTypeId', e.target.value)}
                 style={{   minWidth: "100px",
                height: "35px",
                padding: "5px 15px",
                lineHeight: "18px",
                appearance: "auto", // ensures default arrow shows in most browsers
                WebkitAppearance: "auto",
                MozAppearance: "auto",}}
              >
                <option value="">Select Document</option>
                {documentOptions.map((option, idx) => (
                  <option key={idx} value={option.documentId}>{option.documentType}</option>
                ))}
              </select>

                 {errors.documents?.[index]?.documentTypeId && (
                    <small className="text-danger">{errors.documents[index].documentTypeId}</small>
                  )}
                </div>

            <div className="col-md-4">
              <label>Upload File</label>
              <input
                type="file"
                className="form-control-file  rounded"
                onChange={(e) => handleDocumentChange(index, 'file', e.target.files[0])}
                ref={(el) => (fileInputRefs.current[index] = el)}
              />

              {errors.documents?.[index]?.file && (
                <small className="text-danger">{errors.documents[index].file}</small>
              )}

              
            </div>

              <div className="col-md-2">
           
           
              <i className="fa fa-trash" aria-hidden="true" style={{ color: "#e60b0b", marginTop:"38px"}}  onClick={() => handleRemoveDocument(index)}></i>
           
          </div>
         

         
                </div>
              ))}

    

        <div className="form-group col-md-12">
          {documents.length < 5 && (
          <button type="button" className="login-btn1 btn mt-3" onClick={handleAddDocument}>
             <i className="fa fa-plus" aria-hidden="true"  style={{ color: "#fff"}}></i> Add New Document
          </button>
          )}
        </div>
   


              </div>
                                               

                                                    {/* <!-- Brand Access --> */}

                                                    <h1 className="section-header float-left">Brand Access</h1>
                                                    <FieldArray
                                                        name="brandAccess"
                                                        render={helper => {
                                                            return (<div>
                                                                {values.brandAccess && values.brandAccess.length > 0 && values.brandAccess.map((brandAccess, index) => {
                                                                    return (<DynamicAddMerchantRow
                                                                        // return (<DynamicAddBrandRow

                                                                        setFirstmargin={setFirstmargin}

                                                                        key={index}
                                                                        index={index}
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        setFieldValue={setFieldValue}
                                                                        touched={touched}
                                                                        errors={errors}
                                                                        isSubmitting={isSubmitting}
                                                                        brands={brands}
                                                                        products={brandAccess.products}
                                                                        getProductsList={getProductsData}
                                                                        handleRemoveMerchant={() => helper.remove(index)}
                                                                    />)
                                                                })}
                                                                <button
                                                                    disabled={isSubmitting}
                                                                    type="button"
                                                                    onClick={() => { helper.push({ brand: '', productName: '', margin: '' }) }}
                                                                    className="btn mt-3 submit-btn"
                                                                    htmlFor="gridCheck">Add Brand
                                                                </button>
                                                            </div>)
                                                        }
                                                        }
                                                    >

                                                    </FieldArray>
                                                    <br />
                                                    <div className="form-row"><br />
                                                        <div className="form-group col-md-4">
                                                            <label htmlFor="customCheck">Access</label><br />
                                                            <div className="custom-control custom-checkbox mb-3">
                                                                <input
                                                                    disabled={isSubmitting}
                                                                    style={{ zIndex: '100' }}
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="customCheck"
                                                                    name="merchentApiAccess"
                                                                    value={values.merchentApiAccess}
                                                                    onChange={(e) => { setFieldValue('merchentApiAccess', e.currentTarget.checked) }}>
                                                                </input>
                                                                <label className="custom-control-label" htmlFor="customCheck">API Access</label>
                                                            </div>
                                                        </div>

                                                            <div className="form-group col-md-6">
                                                            <label htmlFor="ipList">Whitelist IPs</label>
                                                            <textarea
                                                                className="form-control"
                                                                id="ipAddress"
                                                                name="ipAddress"
                                                                placeholder="e.g., 192.168.1.1, 192.168.1.20"
                                                                value={values.ipAddress}
                                                                onChange={handleChange}
                                                                disabled={isSubmitting}
                                                            />
                                                           </div>


                                                        
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="token"
                                                                placeholder="Enter token"
                                                                type="text"
                                                                label=" Set Token ID"
                                                                value={values.token}
                                                                onChange={handleChange}
                                                                id="token"
                                                                // error={touched.token && errors.token}
                                                                // errorText={errors.token}
                                                                disabled={isSubmitting}
                                                            />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="authorizationCode"
                                                                id="authorizationCode"
                                                                placeholder="Enter token"
                                                                type="text"
                                                                label="Set Authorization Password"
                                                                value={values.authorizationCode}
                                                                onChange={handleChange}
                                                                // error={touched.authorizationCode && errors.authorizationCode}
                                                                // errorText={errors.authorizationCode}
                                                                disabled={isSubmitting}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="form-row"><br />
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="password"
                                                                id="password"
                                                                placeholder="Enter password"
                                                                type={PwdInputType}
                                                                label="Set Password"
                                                                value={values.password}
                                                                onChange={handleChange}
                                                                error={touched.password && errors.password}
                                                                errorText={errors.password}
                                                                disabled={isSubmitting} 
                                                                isToggle={ values.password ? true: false }
                                                                toggleIcon={ ToggleIcon }/>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                name="cnfmPassword"
                                                                id="cnfmPassword"
                                                                placeholder="Confirm password"
                                                                type="password"
                                                                label="Confirm Password"
                                                                value={values.cnfmPassword}
                                                                onChange={handleChange}
                                                                error={touched.cnfmPassword && errors.cnfmPassword}
                                                                errorText={errors.cnfmPassword}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <label htmlFor="is2faEnabled" className="d-block mb-2">
                                                                Enable 2FA
                                                            </label>
                                                            <div className="custom-control custom-switch">
                                                                <input
                                                                    type="checkbox"
                                                                    className="custom-control-input"
                                                                    id="is2faEnabled"
                                                                    name="is2faEnabled"
                                                                    checked={values.is2faEnabled}
                                                                    onChange={(e) => setFieldValue("is2faEnabled", e.target.checked)}
                                                                    disabled={isSubmitting}
                                                                />
                                                                <label className="custom-control-label" htmlFor="is2faEnabled">
                                                                    {values.is2faEnabled ? "Enabled" : "Disabled"}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <ButtonContained buttonName="Save" disabled={isSubmitting} />
                                                        <LoginDetails loginData={loginData} closeModal={closeModal} showDetailsModal={showDetailsModal} />
                                                    </div>
                                                </Form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* </section> */}
                    </div>
                )
            }}
        </Formik >
    );
}

export default AddMerchant;